import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, Briefcase, Mail, Wallet, Menu, Star } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

/**
 * MobileTabBar — thumb-reachable bottom navigatie voor mobiel/telefoon (< md).
 * Toont de eerste 4 favorieten van de gebruiker (ster op een tegel of lang indrukken in het menu);
 * zonder favorieten de standaardtabs. "Meer" opent het volledige menu.
 */
const STANDAARD = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, tid: "dashboard" },
  { to: "/projecten", label: "Projecten", icon: Briefcase, tid: "projecten" },
  { to: "/mail-dashboard", label: "Mail", icon: Mail, tid: "mail" },
  { to: "/cash-flow", label: "Cashflow", icon: Wallet, tid: "cashflow" },
];
const kort = (s) => (s || "").replace(/\s*\(.*?\)\s*/g, "").split(/[—·]/)[0].trim().slice(0, 12);

export default function MobileTabBar({ onMenuClick, favorieten = [] }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return null;
  const eigen = favorieten.length > 0;
  const favTabs = favorieten.slice(0, 4).map((f) => ({ to: f.to, label: kort(f.label), icon: f.icon || Star, tid: f.tid?.replace(/^nav-/, "") || f.to.replace(/\W+/g, "-") }));
  const tabs = [...favTabs, ...STANDAARD.filter((t) => !favTabs.some((f) => f.to === t.to))].slice(0, 4);

  return (
    <div className="mobile-tab-bar md:hidden pwa-hide-desktop" data-testid="mobile-tab-bar" data-eigen={eigen ? "1" : "0"}>
      <div className="flex items-stretch justify-around">
        {tabs.map((t) => {
          const pad = t.to.split("?")[0];
          const active = location.pathname === pad || location.pathname.startsWith(pad + "/");
          const Icon = t.icon;
          return (
            <NavLink key={t.to} to={t.to} data-testid={`mtb-${t.tid}`}
              className={`flex-1 flex flex-col items-center gap-0.5 py-1.5 no-underline transition min-w-0 ${active ? "mobile-tab-active" : "text-slate-500"}`}>
              <Icon className="h-5 w-5 transition-transform" />
              <span className="text-[10px] font-medium truncate max-w-full px-1">{t.label}</span>
            </NavLink>
          );
        })}
        <button onClick={onMenuClick} data-testid="mtb-more" className="flex-1 flex flex-col items-center gap-0.5 py-1.5 text-slate-500" aria-label="Meer menu-opties">
          <Menu className="h-5 w-5" />
          <span className="text-[10px] font-medium">Meer</span>
        </button>
      </div>
    </div>
  );
}
